import React from "react";

import TableHeaderColumn from "../../shared/TableHeaderColumn.jsx";

import { SORT_COMPANY_ASC, SORT_COMPANY_DESC } from "../../../constants.js";

/**
 * TableHeader Component for the Contract Holders - Small Business table
 * @param {number} sortOption
 * @param {function} setSortOption
 * @returns {React.JSX.Element}
 */
export default function TableHeader({ sortOption, setSortOption }) {
  const companyOnClick = () =>
    sortOption === SORT_COMPANY_ASC ? setSortOption(SORT_COMPANY_DESC) : setSortOption(SORT_COMPANY_ASC);

  return (
    <tr role="row">
      <TableHeaderColumn
        id="company-head"
        text="Company"
        onClick={companyOnClick}
        title="company name"
        sortOption={sortOption}
        sortDesc={SORT_COMPANY_DESC}
      />
      <TableHeaderColumn id="company-head" className="text-center" text="Contract(s)" />
      <TableHeaderColumn id="company-head" className="text-center" text="Business Designation" />
    </tr>
  );
}
